import { render, staticRenderFns } from "./RegistTypeSelect.vue?vue&type=template&id=0b296d6d&scoped=true&"
import script from "./RegistTypeSelect.vue?vue&type=script&lang=js&"
export * from "./RegistTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./RegistTypeSelect.vue?vue&type=style&index=0&id=0b296d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b296d6d",
  null
  
)

export default component.exports